module.exports = __webpack_public_path__ + "static/media/grip-horizontal-line.3f7a8f30.svg";